<template>
  <div id="moveApply" class="only-content">
      <div class="header">
          <Tabs :animated="false" @on-click="tabsClick">
              <TabPane label="离职申请" name="leaveApply">
                  <QuitApply :headers="headers" :companyList="companyList"  :rankTypeList="rankTypeList"   v-if="TabsClicks === 'leaveApply'"></QuitApply>
              </TabPane>
              <TabPane label="关系调整" name="relationMove"  >
                  <RankMove :headers="headers" :companyList="companyList"  v-if="TabsClicks === 'relationMove'"></RankMove>
              </TabPane>
              <TabPane label="人员调动" name="deptMove">
                  <DeptMove :headers="headers" :rankTypeList="rankTypeList" :companyList="companyList"  v-if="TabsClicks === 'deptMove'"></DeptMove>
              </TabPane>
              <!-- <TabPane label="团队合并" name="teamMerge">
                  <TeamMerge :headers="headers" :rankTypeList='rankTypeList' :companyList="companyList" v-if="TabsClicks === 'teamMerge'"></TeamMerge>
              </TabPane> -->
          </Tabs>
      </div>
  </div>
</template>
<script>
// import addForm from './form/addagentfrom.vue/'
// import qualificationApprovalForm from './form/qualificationApprovalForm.vue'
import leaveTableList from '../../../mock/moveManageList.json'
import rankMoveTableList from '../../../mock/rankMoveTable.json'
import relationMoveTableList from '../../../mock/relationMoveTable.json'
import QuitApply from './tabMove/quitApply'
import RankMove from './tabMove/relationMove'
import DeptMove from './tabMove/deptMove'
import TeamMerge from './tabMove/teamMerge'
export default {
    components:{QuitApply,RankMove,DeptMove,TeamMerge},
    data(){
        return{
            headers : {sid : window.sessionStorage.getItem("sid")} ,
            rankTypeList:[],
            TabsClicks: 'leaveApply',
            companyList:{
                customList:[],
                areaList:[],
                groupList:[],
                teamList:[],
                afterAreaList: [],
                afterGroupList: [],
                afterTeamList: [],
            }
        }
    },
    created(){
        this.getLists()

      /*   this.$nextTick(()=>{
            for(let item of document.getElementsByClassName('moreCondition')) {
                item.hidden = true
            }
            for(let item of document.getElementsByClassName('upBtn')) {
                item.hidden = true
            }
        }) */
    },
    computed(){
    },
    methods:{
        tabsClick (name) {
            console.log(name);
            this.TabsClicks = name
        },
        //获取所有列表
        getLists(){
             this.$util.getDeptByLevel(this, "agent", (e) => {
                this.companyList.customList = e;
                });
            /* this.$api.getDeptAndAllSubdivision({
             deptLevelId: '3',
                enableStatus: '0'
            }).then(res => {
                if (res.respCode == '0') {
                    this.companyList.customList = res.data
                }
            }); */
            this.$api.getDeptAndAllSubdivision({
                 deptLevelId: '4',
                enableStatus: '0'
            }).then(res => {
                if (res.respCode == '0') {
                    this.companyList.areaList=res.data;
                    this.companyList.afterAreaList=res.data
                }
            });
            this.$api.getDeptAndAllSubdivision({
                 deptLevelId: '5',
                enableStatus: '0'
            }).then(res => {
                if (res.respCode == '0') {
                    this.companyList.teamList=res.data
                    this.companyList.afterTeamList=res.data
                }
            });
            this.$api.getDeptAndAllSubdivision({
                level: '6',
                enableStatus: '0'
            }).then(res => {
                if (res.respCode == '0') {
                    this.companyList.groupList = res.data
                    this.companyList.afterGroupList = res.data
                }
            });

            this.getPostList();
        },
        //获取职级列表
        getPostList() {
            this.$api.getPostList({
                 enableStatus:0
            }).then(res => {
                if (res.respCode == 0) {
                    this.rankTypeList = res.data
                }
            })
        },

    }
};
</script>
<style   lang="less">


</style>
